import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown, DropdownButton } from "react-bootstrap";
import EditEntityField from "../profile/EditEntityField";
import { useGeVendortUsers, useGetVendorId } from "../../hooks/global/User";

import ImageUploader from "../global/ImageUploader";
import ImageWithFallback from "../global/ImageWithFallback";
import { patchProfile } from "../../patchers/profile";
import { success, error } from "../../hooks/global/ToastAlert";
import SweetAlert from "sweetalert-react";
import { triggerResetPassword } from "../../fetchers/vendor";

function ProfileSettings(props) {
  const vendorId = useGetVendorId();
  const vendor = JSON.parse(localStorage.getItem('vendor'));
  const compProfiles = props.profiles;

  const { t, i18n } = useTranslation();

  const { data: users } = useGeVendortUsers();

  const [profiles, setProfiles] = useState(compProfiles);
  const [showImageUploader, setShowImageUploader] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  const [applicationUser, setApplicationUser] = useState('');

  const [showApiDiv, setShowApiDiv] = useState(false);
  const [resetPasswordPopupVisible, setResetPasswordPopupVisible] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(profiles[0]);
  const [logoSrc, setLogoSrc] = useState(selectedProfile?.logourl);


  useEffect(() => {
    if (users) setApplicationUser(users.find((user) => user.role === "APPLICATION"));
  }, [users]);

  const setSelectedProfileDrop = (profileId) => {

    let selected = profiles.find((profile) => profile.id === profileId);
    
    setSelectedProfile(selected);
    setLogoSrc(selected.logourl);
    setShowImageUploader(false);
  };

  const handleChangeimage = (e) => {
    setShowSpinner(true);
  };

  const handleUpdate = (e) => {
    setLogoSrc(e.data);
    const payload = {};
    payload["fieldName"] = "logo_url";
    payload["fieldValue"] = e.data;
    patchProfile(selectedProfile.id, vendorId, payload).then((res) => {
      setShowSpinner(false);
    });
  };

  const setFieldValue = (fieldName, fieldValue, profileId) => {
    setProfiles(
      profiles.map((profile) => {
        if (profile.id === profileId) {
          profile.fieldName = fieldValue;
        }
        return profile;
      })
    );
  };

  const resetApplicationUserPassword = () => {

    triggerResetPassword(vendorId, applicationUser.email, vendor.name, i18n.language )
      .then(() => {
        success(t("toast.pass"), {
          className: "successToast",
        });
        setResetPasswordPopupVisible(false);
      })
      .catch(() => {
          error(t("errPass"), {
          className: "errorToast",
        });
      });
  };

  return (
    <div>
      {selectedProfile && (
        <div>
          {profiles.length > 1 && (
            <div className="dropdownWrap">
              <span className="label">{t("admin.set.setUn")}</span>

              <DropdownButton
                title={selectedProfile.name}
                id="selectProfileDropdown"
              >
                {profiles.map((profile, key) => {
                  return (
                    <Dropdown.Item
                      key={key}
                      eventKey={profile.id}
                      onClick={() => setSelectedProfileDrop(profile.id)}
                    >
                      {profile.name}
                    </Dropdown.Item>
                  );
                })}
              </DropdownButton>
            </div>
          )}
          <div className="editMe-field">
            <div className="artNamePreview">
              <strong>{t("admin.common.exp")}</strong>
              <em>{t("admin.set.tt2")}</em>
              <EditEntityField
                className="editMe-title"
                fieldName="name"
                fieldValue={selectedProfile.name}
                editType="text"
                showType="text"
                validations={["required"]}
                entityId={selectedProfile.id}
                vendor={{ id: selectedProfile.vendorid, languages: [] }}
                setFieldValue={setFieldValue}
                entityName={"profiles"}
                isMultilanguage={false}
                onSuccess={props.refreshProfiles}
              />
            </div>
            <div className="artImgPreview">
              <div>
                <ImageWithFallback src={logoSrc} alt={t("err.noUrl")} />
                <button
                  className="btn btn-edit"
                  onClick={() => setShowImageUploader(true)}
                >
                  {t("admin.group.picUp")}
                </button>
              </div>
              {showSpinner && (
                <div className="artImgLoader">
                  <div className="loaderAdmin">
                    <div className="loader"></div>
                  </div>
                </div>
              )}
            </div>
            <div className="artImgUploader artImgUploaderProfileSettings">
              <div className="artImgCTA">
                {showImageUploader && (
                  <div className="artImgForm">
                    <span
                      className="closeMe"
                      onClick={() => setShowImageUploader(false)}
                    >
                      {t("admin.common.close")}
                    </span>
                    <ImageUploader index="logo_url" location={`images/merlin/vendors/${vendorId}`} onChange={handleChangeimage} onSave={(e) => { handleUpdate(e); setShowImageUploader(false) }} />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="editMe-field">
            <strong>{t("admin.set.pl")}</strong>
            <em>{t("admin.set.plt")}</em>
            <EditEntityField
              className="editMe-url"
              fieldName="www"
              fieldValue={selectedProfile.www}
              editType="text"
              showType="url"
              validations={["required"]}
              entityId={selectedProfile.id}
              vendor={{ id: selectedProfile.vendorid, languages: ["SL"] }}
              setFieldValue={setFieldValue}
              entityName={"profiles"}
              isMultilanguage={false}
              onSuccess={props.refreshProfiles}
            />
          </div>
          {applicationUser && (
            <div>
              <h5>{t("admin.set.api")}</h5>
              {showApiDiv ? (
                <div>
                  <div className="readMeField readMeFieldNoEdit">
                    <p>{t("admin.set.p1")}</p>
                    <p>{t("admin.set.p2")}</p>
                  </div>
                  <div className="readMeField">
                    <strong>{t("admin.set.id")}:</strong>
                    <em>{selectedProfile.id}</em>
                  </div>
                  <div className="readMeField">
                    <strong>{t("admin.set.us")}:</strong>
                    <em>{applicationUser.email}</em>
                  </div>
                  <div className="readMeField">
                    <strong>{t("common.password")}:</strong>
                    <em>{t("admin.set.p3")}</em>
                    <a onClick={() => setResetPasswordPopupVisible(true)}>
                      {t("admin.set.rApi")}
                    </a>
                  </div>
                </div>
              ) : (
                <div className="readMeField readMeFieldNoEdit">
                  <a
                    className="btnShowMore"
                    onClick={() => setShowApiDiv(true)}
                  >
                    {t("admin.set.de")}
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      )}

<SweetAlert
					show={resetPasswordPopupVisible}
					title={t("warn.warn")}
					type="warning"
					text={t("warn.apiPassRes")}
					confirmButtonText={t("warn.un")}
					cancelButtonText={t("common.ca")}
					onConfirm={() => resetApplicationUserPassword()}
					onCancel={() => setResetPasswordPopupVisible(false)}
					showCancelButton={true}
				/>

    </div>
  );
}

export default ProfileSettings;
